(ns app.front.view.appeals.appeals-section
  (:require [app.domain.appeals.model :as appeals-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [core.db.entity.util :as eu]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::appeals
  :<- [::ws-subs/application]
  (fn [app _]
    (->> app
         :entity/_parent
         (filter (eu/is-type-fn :entity.type/appeals-information))
         (sort-by :appeals-information/date-of-appeal))))

(defn date-display [{:keys [tr entity attr process-target]}]
  (let [tz (<sub [::ws-subs/group-time-zone])]
    (if (<sub [::process/app-signal-permitted?
               [:process.signal/edit-appeal (util/mmap {:id (:db/id entity)}
                                                       attr)]])
      [ui/date-picker {:required? true
                       :callback  #(>evt [::process/signal
                                          process-target
                                          [:process.signal/edit-appeal
                                           (util/mmap {:id    (:db/id entity)
                                                       :value %}
                                                      attr)]])
                       :value     (attr entity)
                       :tr        tr}]
      [:span (date-util/date-in-tz (attr entity) tz)])))

(defn date-col [tr process-target attr]
  [(tr [attr])
   #(vector date-display (util/mmap {:entity %}
                                    attr tr process-target))])


(defn appeals-section []
  (let [tr       (<sub [:tr])
        target   (<sub [::ws-subs/application])
        lang     (<sub [:language])
        date-col (partial date-col tr target)
        appeals  (<sub [::appeals])]
    (when (seq appeals)
      [ws-section/section
       target
       :application-appels
       {:tr tr}
       :appeals/application-appeals
       true
       [:div
        [ui-table/modern-responsive-table
         {:items              appeals
          :tr                 tr
          :row-class-override "overflow-visible lg:items-center"
          :cols               [[(tr [:appeals-information/tribunal])
                                #(-> % :appeals-information/tribunal (appeals-model/appeals-tribunal-name lang))]
                               (date-col :appeals-information/date-of-appeal)
                               (date-col :appeals-information/date-of-meeting)
                               (date-col :appeals-information/date-of-decision)]}]]])))
